import { createAction } from '@reduxjs/toolkit';

import type {
	SvaraFeaturedAchievementDto,
	SvaraPlayerAchievementsResponse,
} from '../../services/api';

export const achievementsHubRequest = createAction('achievements/hub/request');
export const achievementsHubSuccess = createAction<SvaraPlayerAchievementsResponse>(
	'achievements/hub/success',
);
export const achievementsHubFailure = createAction<string>('achievements/hub/failure');

export const achievementShowcaseToggle = createAction<{ familyKey: string }>(
	'achievements/showcase/toggle',
);
export const achievementShowcaseSaveStarted = createAction('achievements/showcase/saveStarted');
export const achievementShowcaseSaveSuccess = createAction<{
	version: number;
	featuredFamilyKeys: string[];
}>('achievements/showcase/saveSuccess');
export const achievementShowcaseSaveFailure = createAction<{ key: string }>(
	'achievements/showcase/saveFailure',
);
export const achievementShowcaseErrorDismiss = createAction('achievements/showcase/errorDismiss');
export const achievementShowcaseRevert = createAction('achievements/showcase/revert');

export const achievementsPlayerFeaturedRequest = createAction<string>(
	'achievements/playerFeatured/request',
);
export const achievementsPlayerFeaturedSuccess = createAction<{
	playerId: string;
	featured: SvaraFeaturedAchievementDto[];
}>('achievements/playerFeatured/success');
export const achievementsPlayerFeaturedFailure = createAction<string>(
	'achievements/playerFeatured/failure',
);
